import ApplicationController from './application_controller'

/**
 * Contrôleur générique pour basculer entre options radio
 * Gère l'affichage/masquage des sections selon l'option sélectionnée
 * Peut être réutilisé pour différents cas d'usage avec des options à basculer
 */
export default class extends ApplicationController {
  static targets = [
    'firstRadio',
    'secondRadio',
    'firstFields',
    'secondFields',
    'firstLabel',
    'secondLabel',
    'fallbackMessage'
  ]

  static values = {
    missingComponentsRole: String
  }

  connect () {
    if (!this.hasFirstRadioTarget || !this.hasSecondRadioTarget) return

    this.updateVisibility()
  }

  toggle () {
    this.updateVisibility()
  }

  selectFirst () {
    if (!this.hasFirstRadioTarget || !this.hasSecondRadioTarget) return

    this.firstRadioTarget.checked = true
    this.secondRadioTarget.checked = false
    this.updateVisibility()
  }

  selectSecond () {
    if (!this.hasFirstRadioTarget || !this.hasSecondRadioTarget) return

    this.secondRadioTarget.checked = true
    this.firstRadioTarget.checked = false
    this.updateVisibility()
  }

  updateFallbackFromComponents (event) {
    if (!this.matchesMissingComponentsRole(event)) return
    if (!this.hasFallbackMessageTarget) return

    if (event.detail?.missingComponents?.length > 0) {
      this.selectFirst()
      this.showElement(this.fallbackMessageTarget)

      return
    }

    this.hideElement(this.fallbackMessageTarget)
  }

  updateVisibility () {
    if (!this.hasFirstRadioTarget || !this.hasSecondRadioTarget) return

    const isFirstSelected = this.firstRadioTarget.checked

    if (isFirstSelected) {
      // Afficher la première section, masquer la seconde
      this.showElement(this.firstFieldsTarget)
      this.hideElement(this.secondFieldsTarget)
      // Visibilité des labels
      this.showElement(this.firstLabelTarget)
      this.hideElement(this.secondLabelTarget)
    } else {
      // Masquer la première section, afficher la seconde
      this.hideElement(this.firstFieldsTarget)
      this.showElement(this.secondFieldsTarget)
      // Visibilité des labels
      this.showElement(this.secondLabelTarget)
      this.hideElement(this.firstLabelTarget)
    }
  }

  matchesMissingComponentsRole (event) {
    return this.hasMissingComponentsRoleValue &&
      event.detail?.role === this.missingComponentsRoleValue
  }

  showElement (element) {
    if (element.classList.contains('hidden')) {
      element.classList.remove('hidden')
    }
  }

  hideElement (element) {
    if (!element.classList.contains('hidden')) {
      element.classList.add('hidden')
    }
  }
}
